import { isSet } from "../../Utils/CommonFunctions";
// export const findPathById = (data, targetId, path = []) =>{
//       for (const [index, item] of data.entries()) {
//         if (item.id === targetId) {
//           return [...path, index];
//         }
//         if (item.data) {
//           const result = findPathById(item.data, targetId, [...path, index, 'data']);
//           if (result) {
//             return result;
//           }
//         }
//       }
//       return '';
// }

export const findPathById = (data, targetId, path = []) => {
  for (const key in data) {
    if (key === 'id' && data[key] === targetId) {
      console.log('data.type',data.type);
      if(data.type==='Body'){
      //if(data.type==='Body' || data.type==='Column'){
        return path = [...path,{key:'children',type:'Object'}];
      }
      return path;
    }
    if (typeof data[key] === 'object') {
      const result = findPathById(data[key], targetId, [...path,{key:key,type:(Array.isArray(data))?'Array':'Object'}]);
      if (result) {
        return result;
      }
    }
  }
  return '';
};

export const valueAssigntoVariable = (valKey,updateValue)=>{
  console.log('valKey,updateValue',valKey,updateValue);
  let returnData = null;
  if (typeof valKey === 'object') {
    if(Array.isArray(valKey)){
      if(typeof updateValue ==='object' && !Array.isArray(updateValue)){
        returnData =  [...valKey,updateValue];
      }else{
        // console.log('ddd');
        returnData =  [...updateValue];//[...valKey,...updateValue];
      }
     
    }else{
      // alert('u');
      returnData =  {...valKey,...updateValue};
      // console.log(returnData,'returnDatareturnData');
    }
  }else{
    // alert('r');
    returnData =  updateValue;
  }
  console.log('returnData',returnData);
  return returnData;  
}

export const  checkAndAddProperties = (lhs, path,key) =>{
  // Iterate through the properties to add
 
    // Check if the property does not exist in the existing object
    console.log('path',path)
    const obj = eval('lhs'+path);
    if (!Array.isArray(obj) && typeof obj === 'object') {
        if(!obj[key]){
          const returnObj =  {
            ...obj,
            [key]:''
          }
          //console.log('updationnnnn====',eval('lhs'+path+'=returnObj'))
          eval('lhs'+path+'=returnObj');
        }
        
    }
    return lhs;
}

export const  formatPath =(path)=> {
    if (!path) {
      return '';
    }
    let pathString = '';
    for (const [index, item] of path.entries()) {
      if(isSet(item.type,null)!==null){
        if(item.type==='Object'){
          pathString += `.${item.key}`;
        }else{
          pathString += `[${item.key}]`;
        }
      }
      // if (typeof step === 'string') {
      //   pathString += `.${step}`;
      // } else {
      //   pathString += `[${step}]`;
      // }
    }
    return pathString;
}

export const styleString =(styleObject)=>{
    return Object.keys(styleObject)
    .map((key) => `${key}: ${styleObject[key]}`)
    .join(', ');
} 


export const findClosestSelectableElement = (element)=>{
  let currentElement = element;

  while (currentElement) {
    const isSelectable = currentElement.getAttribute('data-selectable');
    if (isSelectable === 'true') {
      return currentElement;
    }
    currentElement = currentElement.parentElement;
  }

  return null; // No selectable ancestor found
}

